import { IBreadcrumbItem } from 'office-ui-fabric-react'
import { State } from 'router5'

export type RouteBreadcrumbItem = IBreadcrumbItem & {
  route: {
    name: string
    params: any
  }
}

export const generateRouteBreadcrumbs = (
  route: State
): RouteBreadcrumbItem[] => {
  const splits = route.name.split('.')

  let key = ''

  return splits
    .map((name, i) => {
      if (name === 'index') {
        return null
      }

      key = key === '' ? name : `${key}.${name}`

      const isLastItem = i === splits.length - 1
      const text = name === 'details' ? route.params.id : undefined

      return {
        text,
        key,
        isCurrentItem: isLastItem,
        route: { name: key, params: { ...route.params } },
      }
    })
    .filter((x) => x !== null) as RouteBreadcrumbItem[]
}
